import React from 'react';

import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Tag } from 'antd';

import { t } from '../../config/translations';
import { formatReturnStatusLabel } from '../utils/traceNavigation';
import { getReturnStatusTagColor, ReturnStatusValue } from '../utils/traceStatusDisplay';

debug.registerComponent('ReturnStatusTag');

const returnStatusLabels = () => ({
  pending: t('trace.returnStatus.pending'),
  confirmed: t('trace.returnStatus.confirmed'),
  failed: t('trace.returnStatus.failed'),
});

type ReturnStatusTagProps = {
  status: ReturnStatusValue;
};

export const ReturnStatusTag = ({ status }: ReturnStatusTagProps) => {
  const label = formatReturnStatusLabel(status, returnStatusLabels());
  if (!label) {
    return <span>—</span>;
  }
  return <Tag color={getReturnStatusTagColor(status)}>{label}</Tag>;
};

debug.markInitialized('ReturnStatusTag');
